module.exports = __webpack_public_path__ + "static/media/meh.10a96cfc.svg";